import './active-claims-modal.scss';

import { Box } from '@mui/material';

interface Props {
  insuredName: string;
  policyName: string;
  effectiveDate: string;
  expirationDate: string;
  premium: string;
}

export const ReinstatementDetails = ({
  insuredName,
  policyName,
  effectiveDate,
  expirationDate,
  premium,
}: Props) => {
  const inputWidth = 'auto';
  return (
    <>
      <Box
        className="context"
        style={{ marginRight: '40px', fontSize: '14px', fontWeight: '400' }}
      >
        The effective date of reinstatement is the previous date of cancellation
        for this policy. If you need to change the reinstatement date, then the
        policy should be treated as new business.
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box
          width={inputWidth}
          className="reinstatment-box"
          style={{ marginTop: '20px' }}
        >
          <Box>INSURED</Box>
          <span className="reinstatment-value">{insuredName}</span>
        </Box>

        <Box width={inputWidth} className="reinstatment-box">
          <Box>POLICY</Box>
          <span className="reinstatment-value">{policyName}</span>
        </Box>
        <Box width={inputWidth} className="reinstatment-box">
          <Box>EFFECTIVE DATE</Box>
          <span className="reinstatment-value">{effectiveDate}</span>
        </Box>

        <Box width={inputWidth} className="reinstatment-box">
          <Box>EXPIRATION DATE</Box>

          <span className="reinstatment-value">{expirationDate}</span>
        </Box>

        <Box width={inputWidth} className="reinstatment-box">
          <Box>PREMIUM</Box>

          <span className="reinstatment-value">{premium}</span>
        </Box>
      </Box>
    </>
  );
};
